// Ustawienia wysyłki PUH (hybrydowa e-Doręczenia). Wartości numeryczne muszą się zgadzać
// z enumami po stronie BE (Kwantum.LegalMail.Core.GovEDelivery.Models.Gov*).

export enum EGovProcedingType {
  General = 1,
  Administrative = 2,
  Tax = 3,
  CourtCivil = 4,
  CourtCriminal = 5,
}

export enum EGovCategoryService {
  Economic = 1,
  Priority = 2,
}

export enum EGovPrintingMode {
  Duplex = 1,
  Simplex = 2,
}

export enum EGovOverprintMode {
  Monochrome = 1,
  Color = 2,
}

export enum EGovReturnService {
  ReturnToSender = 1,
  Destroy = 2,
}

export enum EGovShippingMode {
  Registered = 1,
  NotRegistered = 2,
}

export interface IHybridSettings {
  ProcedingType: EGovProcedingType;
  CategoryService: EGovCategoryService;
  PrintingMode: EGovPrintingMode;
  OverprintMode: EGovOverprintMode;
  ReturnService: EGovReturnService;
  ShippingMode: EGovShippingMode;
  ProofOfDelivery: boolean;
}

export const defaultHybridSettings = (): IHybridSettings => ({
  ProcedingType: EGovProcedingType.Administrative,
  CategoryService: EGovCategoryService.Economic,
  PrintingMode: EGovPrintingMode.Duplex,
  OverprintMode: EGovOverprintMode.Monochrome,
  ReturnService: EGovReturnService.ReturnToSender,
  ShippingMode: EGovShippingMode.Registered,
  ProofOfDelivery: false,
});
